var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImacsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 194,
    height: 76,
    viewBox: "220 490 356 140",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4.9603173e-8,1.1243386e-6 H 1.0000001 V 0.99999979 H -4.9603173e-8 Z",
    clipRule: "evenodd",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 345.76001,706.88 0.16,0.15997 V 706.88 Z m 1.75998,0 0.64001,0.15997 V 706.88 Z m -1.44,0.15997 0.48001,0.16004 v -0.16004 z m -1.75998,0.16004 0.16,0.15997 v -0.15997 z m 1.28,0 0.47998,0.15997 v -0.15997 z m -1.76001,0.15997 0.16,0.16003 v -0.16003 z m 1.44,0 0.16,0.16003 v -0.16003 z m 5.28,0 0.16,0.16003 v -0.16003 z m -7.20001,0.16003 0.16,0.15998 v -0.15998 z m 1.12002,0.15998 0.16,0.16003 v -0.16003 z m -0.64001,0.16003 -0.48001,0.15997 0.32,0.32001 -0.32,0.32001 0.48001,0.15997 0.16,0.16004 -0.16,0.15997 -0.32001,0.16003 0.32001,0.31995 -0.32001,0.32001 V 709.76 h -0.16 l -0.15998,0.15998 -0.16,0.32 -0.48001,0.47999 0.32,0.16003 v 0.32001 h 0.32001 l 0.15998,0.15997 0.32,0.16003 v -0.16003 H 343.84 l 0.16,0.16003 0.32001,0.15998 v 0.32 h 0.16 L 344.16,712.32 l 0.16001,0.15997 -0.16001,0.16004 -0.48001,0.15997 -0.79999,0.16004 v -0.80005 h -0.48001 l -0.16,0.16003 v 0.32001 l -0.31998,-0.16004 h -0.16 v -0.32 h -0.16 v 0.80005 h -0.64002 v 0.32 l 0.16001,-0.16003 h 0.32 l 0.16001,0.16003 v 0.31995 H 341.28 l -0.32001,0.16003 v -0.16003 h -0.31998 l -0.16,0.16003 v -0.32 l -0.16,-0.15998 0.16,-0.32 h 0.47998 v -0.32001 l 0.32001,-0.64002 -0.32001,-0.15997 h -0.16 l -0.15998,0.15997 -0.32,0.15998 v 0.48004 H 340 l -1.60001,0.79999 v -0.32001 l 0.16001,-0.47998 -0.16001,-0.16004 h -0.16 l -0.16,0.32001 0.16,0.16004 v 0.32 h -0.31998 l -0.16,0.79999 -0.16,0.15997 -0.16001,0.79999 -0.16,1.60004 0.32001,0.32001 v -0.32001 l 0.32,-0.32001 0.31998,-0.16003 H 338.56 l 0.16,0.16003 v -0.16003 h 0.32001 L 338.88,716.32 l 0.32001,0.15997 v 0.32001 h 0.15998 l 0.16,0.16004 V 717.44 h 0.16 l 0.48001,0.15997 0.16001,0.16003 -0.16001,0.15998 0.16001,0.16003 -0.16001,0.15997 -0.48001,0.16004 -0.16,0.15997 v -0.15997 l -0.47998,-0.16004 h -0.80002 l 0.16,0.16004 -0.16,0.15997 v -0.15997 h -0.16 v -0.48004 L 337.92001,717.76 h -0.16 v -0.32 h -0.16 v -0.32001 H 337.44 v 1.11999 h 0.16001 v 0.79999 h 0.16 v 0.48004 h 0.16 v 0.63996 l 0.15998,-0.63996 0.16,-0.48004 h 0.16 v 0.32001 l 0.32001,-0.32001 0.48001,-0.15997 h 0.31998 l 0.16,0.15997 -0.16,0.16004 0.32001,0.15997 v 0.32001 H 340 l -0.16,0.16003 -0.16001,0.31995 -0.32,0.16003 0.32,0.15997 -0.16,0.16004 0.16,0.15997 -0.16,0.32001 0.16,0.16003 v 0.31995 H 339.84 v 0.32001 H 340 l 0.32001,0.16003 0.16,0.15997 v -0.15997 h 0.31998 V 721.76 l 0.64001,-0.16003 h -0.64001 v -0.31995 l 0.16,-0.16003 h -0.63998 v -0.32001 L 340.16,720.64001 H 340 l -0.16,0.15997 V 720.32 l 0.32,-0.32001 h 0.16001 l 0.16,0.15998 v -0.31995 h -0.16 v -0.32001 l 0.63998,-0.16003 0.16001,-0.15997 h 0.64001 l 0.31998,0.15997 v -0.32001 h 0.32 l 0.16001,0.16004 -0.16001,0.15997 v 0.32001 l -0.32,-0.15998 h -0.15998 v 1.12 l 0.15998,-0.16004 H 342.56 v -0.47998 l 0.16,-0.15997 h 0.16 v 0.31995 h 0.16001 v 0.32 h 0.16 v 0.32001 H 342.88 v 0.32001 h 0.16001 l 0.16,0.16003 0.47998,0.15998 -0.16,0.32 0.32001,0.15998 0.16,0.16003 v 0.32001 h 0.64001 l 0.15998,0.15997 V 722.88 H 345.12 v 0.32001 h 0.16 l 1.28,0.15997 0.16,0.16003 -0.95999,0.15998 -0.16,0.16003 V 724.32 h 0.16 l -0.16,0.47998 0.32,0.32001 2.07999,0.16003 v -0.32 l -0.16,-0.16004 h -0.32001 V 724.32 H 348 l 0.79999,0.15997 v -0.32 l -0.15998,-0.15998 0.31998,-0.15997 1.12,-0.16003 0.16,-0.64002 0.16,-0.15997 -0.63998,-0.64002 0.63998,-0.15997 -0.32,-0.16003 -0.15998,-0.15998 0.31998,-0.16003 -0.16,-0.15997 0.32,-0.15998 h -0.32 v -0.32 l 0.16,-0.32001 -0.16,-0.16004 h 0.32 l 0.32001,0.16004 V 720.32 l 0.32001,-0.32001 0.16,-0.32 -0.16,-0.15998 0.79999,-0.80004 0.48001,-0.15998 0.16,-0.32001 0.16,-0.47998 0.15998,-0.32 0.16,-0.47998 0.16001,-0.32001 0.16,-0.48004 h 0.32001 l 0.63998,0.32 0.16,0.16004 1.12,0.15997 0.32001,0.32001 V 717.44 H 356 l 0.64001,0.15997 0.47999,0.16003 v -2.72003 h -0.16001 v -0.79999 h -0.16 V 713.76 h -0.15998 v -0.47998 h -0.16 v -0.48004 h -0.16 v -0.32001 L 356.16,712.32 H 356 v -0.32001 l -1.12,-1.11999 -0.32,-0.16003 -0.16001,-0.15998 -0.32,-0.15997 -0.15998,-0.16004 -0.32,-0.15997 -0.80002,-0.16003 -1.12,-0.15998 -0.32,-0.16003 H 350.72 l 0.32001,0.32001 v 0.32 H 350.72 l -0.16,0.16004 0.16,0.15997 V 710.88 h 0.16 v 0.32001 h 0.16001 v 0.64001 h 0.31998 l -0.15998,0.31995 -0.64001,0.32 -0.32001,0.32001 -0.16,0.32001 -0.15998,0.16003 L 349.12,713.44 v -0.15998 H 348 l -0.64001,0.15998 v -0.15998 l -0.96,-0.48004 -0.32,-0.32001 h -1.12 v -0.47998 l -0.47998,-0.47998 h -0.16 v -0.32 H 344.16 V 710.88 H 344 v -0.47998 L 343.84,710.23998 344,709.76 h 0.16 l 0.48001,0.15998 v -0.32001 l 0.15998,-0.31995 0.16,-0.48004 0.16001,-0.15997 h -0.63999 v -0.79999 z m -1.60001,0.47998 -0.16,0.32001 -0.15998,0.15997 -0.32,0.16004 0.16,0.15997 0.31998,0.16003 v -0.16003 l 0.48001,-0.15997 0.16,-0.16004 -0.32001,-0.32001 L 342.56,708.32 Z m 10.40002,0 0.15998,0.15997 V 708.32 Z m 0.15998,0.15997 0.16,0.16004 v -0.16004 z m -11.35999,0.16004 0.16001,0.15997 v -0.15997 z m 1.76001,0.15997 0.15998,0.16004 v -0.16004 z m 10.07999,0 0.16,0.16004 v -0.16004 z m -10.4,0.16004 0.32001,0.15997 v -0.15997 z m 0.32001,0.47998 0.15998,0.15997 V 709.44 Z m 10.87998,0 0.16,0.15997 V 709.44 Z m 0.16,0.15997 0.16,0.16003 v -0.16003 z m 0.16,0.16003 0.16001,0.15998 V 709.76 Z m -12,0.47998 0.16001,0.16004 v -0.16004 z m -0.16,0.16004 0.16,0.15997 v -0.15997 z m 0.96002,0 0.31998,0.15997 v -0.15997 z m -4.16,0.63995 0.16,0.16004 v -0.16004 z m 1.44,0 -0.48001,0.16004 -0.32001,0.15997 v 0.64001 l 0.16001,-0.32 0.32,-0.15998 h 0.16001 l 0.32,0.32001 v -0.16003 l 0.15998,-0.15998 h -0.15998 v -0.48004 z m 2.87998,0 0.16,0.16004 v -0.16004 z m 12,0 0.16,0.16004 v -0.16004 z m 0.32,0.48004 0.16001,0.15998 v -0.15998 z m -16.79999,0.32001 0.16001,0.15997 v -0.15997 z m 1.44001,0 0.16,0.15997 v -0.15997 z m -1.60001,0.15997 0.16,0.15998 v -0.15998 z m 0.79999,0 0.16,0.15998 v -0.15998 z m 0.64001,0 0.16001,0.15998 v -0.15998 z m -0.95999,0.15998 0.15998,0.16003 v -0.16003 z M 338.56,712.32 l 0.16,0.15997 V 712.32 Z m 0.79999,2.71997 v 0.32001 h 0.16 v 0.48004 l 0.16,-0.32001 0.16001,-0.16003 h -0.16001 v -0.32001 z m 13.28002,3.36005 0.15998,0.15997 v -0.15997 z m -0.32,0.31995 v 0.32 l 0.16,-0.32 z m 4.47998,0 -0.15998,0.16003 -0.16,0.32001 -3.36001,3.35998 -0.32001,0.15998 -1.91999,0.32 -0.32,0.16004 0.16,0.15997 -0.64001,0.64001 -0.31998,0.15998 -0.32001,0.32 -0.32,0.16004 -0.47999,0.47998 -0.16,0.32001 v 0.32 H 348.16 l -3.51999,0.15998 -0.32,0.16003 0.63998,0.15997 0.80002,0.16004 3.19998,0.15997 v -0.15997 l 1.28,-0.32001 0.96002,-0.32001 0.31998,-0.16003 0.16,-0.15997 0.96002,-0.47998 0.15998,-0.16004 0.32001,-0.15997 0.32,-0.32001 0.32001,-0.16003 0.95999,-0.95996 0.16,-0.32001 0.47999,-0.47998 0.32,-0.64002 0.16001,-0.16003 0.48001,-0.95996 0.32,-0.96002 0.15998,-0.64002 0.16,-0.32 z m -18.87998,0.32 0.15998,0.16004 v -0.16004 z m 0.31998,0.48004 v 0.63996 l 0.48001,-0.47998 -0.16,-0.15998 z m 0.80002,0 0.16,0.15998 v -0.15998 z m -0.16001,0.15998 v 0.32 h 0.16001 l 0.31998,0.15998 v -0.31995 l -0.31998,-0.16003 z m -0.32,0.32 0.16,0.15998 v -0.15998 z m -0.16001,0.15998 v 0.32 H 338.56 l 0.32,0.32001 v -0.32001 l -0.32,-0.32 z m 0.32001,0 0.32001,0.16003 v -0.16003 z m -0.64001,0.16003 v 0.32001 l 0.16,-0.32001 z m 1.12002,0.15997 0.15998,0.16004 v -0.16004 z m -0.96002,0.16004 v 0.32001 h 0.16 l 0.16001,0.15997 v -0.32001 l -0.16001,-0.15997 z m 0.64001,0.15997 v 0.32001 l 0.16001,-0.32001 z m 3.19999,0 0.16,0.16004 v -0.16004 z m -3.51999,0.32001 0.16,0.16003 v -0.16003 z m 9.76001,0.32001 0.32,0.15997 V 721.44 Z m -0.16001,0.47998 -0.16,0.32 0.32001,0.32001 v -0.15997 l 0.32,-0.16004 h -0.16 v -0.32 z m -5.28,0.16003 v 0.32001 l 0.16001,-0.32001 z m -0.48001,0.15997 v 0.47999 l 0.48001,-0.15998 -0.32,-0.15997 0.16,-0.16004 z m 0.64002,0.16004 v 0.31995 l 0.16,-0.31995 z m -1.44,0.15997 0.16,0.15998 0.31998,0.16003 v -0.32001 z m 0.63998,0.15998 0.16,0.16003 v -0.16003 z m 0.96002,0 0.15998,0.16003 v -0.16003 z m -0.80002,0.16003 v 0.32001 L 342.88,723.03997 342.72,722.88 Z m 5.44001,0 0.16,0.15997 V 722.88 Z m -5.91999,0.15997 0.15998,0.16004 v -0.16004 z m 4.95999,0 0.16001,0.16004 v -0.16004 z m 0.79999,0 -0.16,0.16004 0.32001,0.15997 v -0.32001 z m 0.80002,0 0.31998,0.16004 v -0.16004 z m -5.60001,0.16004 0.16001,0.15997 v -0.15997 z m 4.32001,0.15997 v 0.64001 l 0.15998,-0.15997 0.16,-0.48004 z m -6.88,0.32001 0.16,0.16003 v -0.16003 z m 0.16,0.16003 0.16,0.15997 v -0.15997 z m 0.16,0.15997 0.15998,0.15998 v -0.15998 z m 0.47999,0.32001 0.16,0.15997 V 724.32 Z m 0.16,0.15997 0.16,0.16004 v -0.16004 z m 0.16,0.16004 0.16001,0.15997 v -0.15997 z m 0.16001,0.15997 0.16,0.16004 v -0.16004 z m 0.32,0.16004 0.15998,0.15997 v -0.15997 z m 1.12,0.63995 0.31998,0.16003 v -0.16003 z m 0.31998,0.16003 0.48001,0.15998 V 725.76 Z m 0.48001,0.15998 0.32,0.16003 v -0.16003 z m 1.28,0.16003 1.6,0.15997 v -0.15997 z",
    clipRule: "evenodd",
    id: "path7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,-2.1474359e-6 H 0.99999944 V 1.0000003 H 0 Z",
    clipRule: "evenodd",
    id: "path9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 353.28,716.15997 -0.16,0.48004 -0.16001,0.32001 -0.16,0.47998 -0.15998,0.32 -0.16,0.47998 -0.16,0.32001 0.16,0.15998 -0.16,0.32 v -0.32 H 351.84 l -0.79999,0.80004 0.16,0.15998 -0.16,0.32 L 350.72,720.32 v 0.32001 l -0.32001,-0.16004 h -0.32 l 0.16,0.16004 -0.16,0.32001 v 0.32 h 0.32 l -0.32,0.15998 0.16,0.15997 -0.31998,0.16003 0.15998,0.15998 0.32,0.16003 -0.63998,0.15997 0.63998,0.64002 -0.16,0.15997 -0.16,0.64002 -1.12,0.16003 -0.31998,0.15997 0.15998,0.15998 v 0.32 L 348,724.32 h -0.48001 v 0.47998 H 347.84 l 0.16,0.16004 v 0.32 l -2.07999,-0.16003 -0.32,-0.32001 0.16,-0.47998 h -0.16 v -0.47998 l 0.16,-0.16003 0.95999,-0.15998 -0.16,-0.16003 -1.28,-0.15997 h -0.16 V 722.88 h -0.32001 v -0.32001 l -0.15998,-0.15997 H 344 v -0.32001 l -0.16,-0.16003 -0.32001,-0.15998 0.16,-0.32 -0.47998,-0.15998 -0.16,-0.16003 H 342.88 v -0.32001 h 0.32001 v -0.32001 h -0.16 v -0.32 H 342.88 v -0.31995 h -0.16 l -0.16,0.15997 v 0.47998 h -0.48001 l -0.15998,0.16004 v -1.12 h 0.15998 l 0.32,0.15998 v -0.32001 l 0.16001,-0.15997 -0.16001,-0.16004 h -0.32 v 0.32001 l -0.31998,-0.15997 H 341.12 l -0.16001,0.15997 -0.63998,0.16003 v 0.32001 h 0.16 l -0.16,0.31995 v -0.15998 H 340.16 l -0.32,0.32001 v 0.32001 h 0.32 l 0.16001,0.15997 v 0.32001 h 0.63998 l -0.16,0.16003 v 0.31995 H 341.44 l -0.64001,0.16003 v 0.32001 h -0.31998 l -0.16,0.15997 v -0.15997 L 340,721.91998 h -0.16 v -0.32001 h -0.16001 v -0.31995 l -0.16,-0.16003 0.16,-0.32001 -0.16,-0.15997 0.16,-0.16004 h -0.32 l -0.15998,0.16004 v -0.16004 l 0.15998,-0.15997 0.32,-0.16003 0.16001,-0.31995 0.16,-0.16003 h -0.16 v -0.32001 l -0.32001,-0.15997 0.16,-0.16004 -0.16,-0.15997 h -0.31998 l -0.48001,0.15997 -0.32001,0.32001 0.32001,0.32001 -0.16,0.16003 0.16,0.15997 0.32001,0.15998 v -0.15998 H 338.88 v -0.32 l 0.16001,-0.15998 h 0.16 l -0.16,0.15998 0.31998,0.16003 v 0.31995 h -0.31998 L 338.72,720.32 l 0.16,0.15997 v 0.32001 h 0.16001 l -0.16001,0.32001 v -0.32001 l -0.32,-0.32001 h -0.16001 v -0.32 h -0.16 v -0.47998 h -0.16 V 720.32 h 0.16 v 0.32001 h 0.16 l 0.16001,0.15997 v 0.32001 h 0.16 l -0.16,0.16003 0.16,0.15998 v 0.32 h 0.16 v 0.32001 h 0.16001 v 0.32001 h 0.16 v 0.31995 h 0.15998 l 0.48001,0.48004 v 0.32 h 0.32 v 0.32001 l 0.16001,-0.16003 h 0.16 l 0.47998,0.47998 v 0.32 L 341.12,724.32 h 0.16 l 0.48001,0.47998 0.31998,0.16004 0.16,0.15997 0.64001,0.32001 0.96,0.32 0.32,0.15998 0.48001,0.16003 v -0.16003 L 348.16,725.76 h 0.32001 v -0.32 l 0.16,-0.32001 0.47999,-0.47998 0.32,-0.16004 0.32001,-0.32 0.31998,-0.15998 0.64001,-0.64001 -0.16,-0.15997 0.32,-0.16004 1.91999,-0.32 0.32001,-0.15998 3.36001,-3.35998 0.16,-0.32001 0.15998,-0.16003 L 357.12,717.76 356.64001,717.59997 356,717.44 h -0.16 v -0.32001 l -0.32001,-0.32001 -1.12,-0.15997 -0.16,-0.16004 -0.63998,-0.32 z m -0.63999,2.24005 0.15998,0.15997 v -0.15997 z m -14.72,1.11999 0.15998,0.15998 v -0.15998 z m 0.63999,0.63996 0.16,0.16003 v -0.16003 z m 3.51999,0.64001 0.16,0.16004 v -0.16004 z m -3.68,0.32001 0.16001,0.16003 v -0.16003 z m 4.48001,0.96002 v 0.32001 l 0.16001,-0.32001 z m -0.48001,0.15997 v 0.47999 l 0.48001,-0.15998 -0.32,-0.15997 0.16,-0.16004 z m 0.64002,0.16004 v 0.31995 l 0.16,-0.31995 z m -1.44,0.15997 0.16,0.15998 0.31998,0.16003 v -0.32001 z m 0.63998,0.15998 0.16,0.16003 v -0.16003 z m 0.96002,0 0.15998,0.16003 v -0.16003 z m -0.80002,0.16003 v 0.32001 L 342.88,723.03997 342.72,722.88 Z m -0.47998,0.15997 0.15998,0.16004 v -0.16004 z m 0.95999,0.16004 0.16001,0.15997 v -0.15997 z m 2.24,2.88 1.6,0.15997 v -0.15997 z",
    clipRule: "evenodd",
    id: "path10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1.2083333e-5 H 0.999975 V 0.99999708 H 0 Z",
    clipRule: "evenodd",
    id: "path11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 337.92001,719.03997 0.15998,0.16004 v -0.16004 z m 0.31998,0 v 0.48004 l 0.16,-0.48004 z",
    clipRule: "evenodd",
    id: "path12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.1249999e-6,8.6309524e-6 H 0.99997812 V 1.0000042 H 3.1249999e-6 Z",
    clipRule: "evenodd",
    id: "path13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 339.35999,715.03997 v 0.32001 h 0.16 v 0.48004 l 0.16,-0.32001 0.16001,-0.16003 h -0.16001 v -0.32001 z",
    clipRule: "evenodd",
    id: "path14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.4999999e-6,1.8518518e-6 H 0.9999875 V 1.0000032 H 2.4999999e-6 Z",
    clipRule: "evenodd",
    id: "path15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 347.84,722.88 0.16,0.15997 V 722.88 Z m -0.16001,0.15997 -0.16,0.16004 0.32001,0.15997 v -0.32001 z m -0.47998,0.32001 v 0.64001 l 0.15998,-0.15997 0.16,-0.48004 z",
    clipRule: "evenodd",
    id: "path16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.2500001e-6,4.9305556e-5 H 0.99998125 V 1.0000097 H 6.2500001e-6 Z",
    clipRule: "evenodd",
    id: "path17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 348.32001,721.44 h 0.32 v 0.15997 h -0.32 z",
    clipRule: "evenodd",
    id: "path18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.5625e-6,-2.8645833e-5 H 0.99997344 V 0.99989948 H -1.5625e-6 Z",
    clipRule: "evenodd",
    id: "path19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 343.20001,710.40002 h 0.31998 v 0.15997 h -0.31998 z",
    clipRule: "evenodd",
    id: "path20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -3.125e-5,-3.2291667e-5 h 1.000025 V 0.99998958 h -1.000025 z",
    clipRule: "evenodd",
    id: "path21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 343.35999,711.03997 h 0.16 v 0.16004 h -0.16 z",
    clipRule: "evenodd",
    id: "path22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -7.8124999e-6,-2.5520833e-5 H 1.0000156 V 0.9999026 H -7.8124999e-6 Z",
    clipRule: "evenodd",
    id: "path23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 343.51999,709.59997 v 0.32001 l 0.32001,-0.32001 z",
    clipRule: "evenodd",
    id: "path24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.4642857e-6,-2.4305556e-5 H 1 V 0.99993507 H 4.4642857e-6 Z",
    clipRule: "evenodd",
    id: "path25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 341.12,713.11999 -0.16001,0.16003 -0.16,0.15998 0.16,0.15997 0.32001,0.16003 v -0.16003 h 0.32001 v -0.31995 L 341.44,713.11999 Z",
    clipRule: "evenodd",
    id: "path26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.5e-6,7.6388889e-6 H 1.0000062 V 0.99999878 H 2.5e-6 Z",
    clipRule: "evenodd",
    id: "path27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 341.28,712.15997 -0.16,0.16003 -0.16001,0.32001 v 0.32001 h 0.64002 v -0.80005 z m -0.79999,0.80005 -0.16,0.32 0.16,0.15998 v 0.32 l 0.31998,-0.32 0.16,-0.47998 z",
    clipRule: "evenodd",
    id: "path28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -2.1186442e-7,3.2196969e-6 H 1.0000001 V 1.0000001 H -2.1186442e-7 Z",
    clipRule: "evenodd",
    id: "path30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 347.04001,706.71997 345.12,706.88 l -1.28,0.32001 -0.16001,0.15997 -0.32,0.16003 -0.47999,0.15998 -0.64001,0.32 -0.31998,0.32001 -0.32,0.15997 v 0.32001 H 341.12 l -1.76001,1.76001 -0.15998,0.32001 -0.16,0.15997 -0.32001,0.64002 -0.16,0.16003 -0.16001,0.31995 -0.16,0.16003 0.32001,0.32001 -0.16001,0.47998 V 713.44 L 340,712.64001 h 0.32001 v -0.48004 l -0.16001,-0.15998 0.32001,-0.32 -0.16,-0.15998 H 340.16 l -0.32,0.15998 -0.16001,0.32 -0.16,0.15998 v -0.15998 l 0.16,-0.64001 0.32001,-0.15997 0.48001,-0.16004 h 0.16 v 0.48004 h 0.15998 l -0.47998,0.47998 0.32,0.15998 v -0.15998 l 0.15998,-0.15997 h 0.16 l 0.32001,0.15997 0.48001,0.15998 v 0.32 h 0.16 l 0.31998,0.16004 V 712.32 l 0.16,-0.16003 H 342.88 v 0.80005 l 0.79999,-0.16004 0.48001,-0.15997 0.16001,-0.16004 -0.16001,-0.15997 0.32001,-0.32001 h -0.16 v -0.32 L 344,711.52001 l -0.16,-0.16003 h -0.16001 l -0.32,0.16003 v -0.16003 l -0.15998,-0.15997 H 342.88 V 710.88 l -0.32,-0.16003 0.48001,-0.47999 0.16,-0.32 0.47998,-0.47998 -0.16,-0.15998 0.32001,-0.16003 0.16,-0.15997 -0.16,-0.16004 h -0.48001 l -0.15998,0.16004 -0.32001,0.15997 v -0.15997 l 0.32001,-0.16004 0.47998,-0.47998 -0.32,-0.32001 0.48001,-0.15997 0.64001,-0.16003 h 0.16 l -0.16,0.16003 v 0.79999 H 345.12 l -0.16001,0.15997 -0.16,0.48004 -0.15998,0.31995 v 0.32001 L 344.16,709.76 H 344 l -0.16,0.47998 0.16,0.16004 V 710.88 h 0.16 v 0.32001 h 0.16001 v 0.32 h 0.16 l 0.47998,0.47998 v 0.47998 h 1.12 l 0.32,0.32001 0.96,0.48004 L 348,713.44 v -0.15998 h 1.12 l 0.80001,0.15998 v -0.15998 l 0.15998,-0.16003 0.16,-0.32001 0.32001,-0.32001 0.64001,-0.32 0.15998,-0.31995 h -0.31998 v -0.64001 H 350.88 V 710.88 h -0.16 v -0.32001 l -0.16,-0.15997 0.16,-0.16004 h 0.32001 v -0.32 L 350.72,709.59997 h 0.63999 l 0.32,0.16003 1.12,0.15998 0.80002,0.16003 0.32,0.15997 0.15998,0.16004 0.32,0.15997 0.16001,0.15998 0.32,0.16003 0.79999,0.79999 v -0.47998 h -0.32 V 710.88 h -0.15998 v -0.32001 l -1.6,-1.59997 -0.32001,-0.16004 -0.16,-0.15997 -0.32001,-0.16004 -0.31998,-0.32 -0.64001,-0.31995 -0.16001,-0.16003 -0.32,-0.15998 -0.79999,-0.16003 -0.16001,-0.15997 -0.47998,-0.16004 -0.64001,-0.15997 -0.48001,-0.16003 h -0.15998 l -0.96002,0.16003 v -0.16003 z m -0.96002,0.32 0.48001,0.16004 v -0.16004 z m -0.47998,0.16004 0.47998,0.15997 v -0.15997 z m -0.32001,0.15997 0.16,0.16003 v -0.16003 z m -3.04001,0.96002 -0.16,0.32001 -0.15998,0.15997 -0.32,0.16004 0.16,0.15997 0.31998,0.16003 v -0.16003 l 0.48001,-0.15997 0.16,-0.16004 -0.32001,-0.32001 L 342.56,708.32 Z m 0.96002,1.12 0.15998,0.15997 V 709.44 Z m -0.80002,0.79998 0.16001,0.16004 v -0.16004 z m -0.16,0.16004 0.16,0.15997 v -0.15997 z m 13.44,1.27997 0.16001,0.16003 v -0.16003 z m -16.79999,0.16003 0.16001,0.15997 v -0.15997 z m 16.96,0 0.16,0.15997 v -0.15997 z m -17.12,0.15997 0.16,0.15998 v -0.15998 z m 0.48001,0.15998 0.15998,0.16003 v -0.16003 z m 16.79999,0 0.16,0.16003 v -0.16003 z m -17.44,0.16003 0.16,0.15997 V 712.32 Z m 17.6,0 0.16001,0.15997 V 712.32 Z m -18.23999,0.79999 0.15998,0.16003 v -0.16003 z m -0.16,0.32001 0.16,0.15997 V 713.44 Z",
    clipRule: "evenodd",
    id: "path31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -6.25e-6,1.8541667e-5 h 0.999975 V 1.0000029 H -6.25e-6 Z",
    clipRule: "evenodd",
    id: "path32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 338.07999,712.96002 v 0.32 l 0.16,-0.32 z m -0.31998,0.79998 v 0.32001 l 0.16,-0.32001 z",
    clipRule: "evenodd",
    id: "path33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.2500001e-6,3.0555556e-5 H 1.0000292 V 1.0001181 H 6.2500001e-6 Z",
    clipRule: "evenodd",
    id: "path34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 339.84,720.64001 H 340 v 0.15997 h -0.16 z",
    clipRule: "evenodd",
    id: "path35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -9.375e-6,-2.4305555e-5 H 1.0000125 V 0.99993507 H -9.375e-6 Z",
    clipRule: "evenodd",
    id: "path36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 338.07999,719.52001 h 0.16 v 0.15998 h -0.16 z",
    clipRule: "evenodd",
    id: "path37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,-2.8645833e-5 H 1.0000234 V 0.99989792 H 0 Z",
    clipRule: "evenodd",
    id: "path38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 338.39999,719.99999 0.16001,0.15998 v -0.15998 z m 0.16001,0.32001 0.16,0.15997 V 720.32 Z",
    clipRule: "evenodd",
    id: "path39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.5789473e-7,9.0686275e-6 H 1.0000036 V 0.99999841 H 6.5789473e-7 Z",
    clipRule: "evenodd",
    id: "path40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 338.23999,716.15997 -0.31998,0.16003 -0.32,0.32001 -0.16001,0.32001 0.16001,0.15997 V 717.44 h 0.16 v 0.32 h 0.16 l 0.15998,0.15998 v 0.48004 l 0.16,-0.16004 h 0.80002 l 0.47998,0.16004 0.16,0.15997 v -0.15997 l 0.48001,-0.16004 0.16001,-0.15997 L 340.16,717.91998 340.32001,717.76 340.16,717.59997 339.67999,717.44 h -0.16 v -0.47998 l -0.16,-0.16004 h -0.15998 v -0.32001 L 338.88,716.32 l 0.16001,-0.16003 H 338.72 l -0.16,0.16003 v -0.16003 z m 0,2.24005 0.16,0.15997 v -0.15997 z",
    clipRule: "evenodd",
    id: "path41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.1249999e-6,-3.2291667e-5 H 1.0000281 V 0.99998958 H 3.1249999e-6 Z",
    clipRule: "evenodd",
    id: "path42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 346.88,723.03997 h 0.16001 v 0.16004 H 346.88 Z",
    clipRule: "evenodd",
    id: "path43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,4.1666667e-6 H 1.0000234 V 0.9999997 H 0 Z",
    clipRule: "evenodd",
    id: "path44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 348.16,721.91998 -0.16,0.32 0.32001,0.32001 v -0.15997 l 0.32,-0.16004 h -0.16 v -0.32 z",
    clipRule: "evenodd",
    id: "path45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.2500001e-6,-3.2291667e-5 H 0.99998125 V 0.99998958 H 6.2500001e-6 Z",
    clipRule: "evenodd",
    id: "path46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 348.48001,723.03997 h 0.31998 v 0.16004 h -0.31998 z",
    clipRule: "evenodd",
    id: "path47"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m 242.48,531.27999 v 61.11999 c 0,1.28001 -0.96,2.40001 -2.24,2.40001 -7.36,0 -13.44,-6.08001 -13.44,-13.44 v -58.24 c 0,-1.28 1.12,-2.4 2.4,-2.4 h 2.72 c 5.92,0 10.56,4.8 10.56,10.56 z",
    style: {
      fill: "#005091",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 257.03999,557.52001 11.68,11.68 c 0.48,0.32 0.64,0.8 0.64,1.44 v 22.08 c 0,1.12 -0.8,2.07999 -1.92,2.07999 h -11.68 c -1.12,0 -2.08,-0.95999 -2.08,-2.07999 v -33.76 c 0,-1.76 2.08,-2.72 3.36,-1.44 z m 63.2,-35.20001 v 70.40001 c 0,1.12 -0.96,2.07999 -2.08001,2.07999 h -11.68 c -1.11999,0 -1.91999,-0.95999 -1.91999,-2.07999 v -33.12 c 0,-1.76 -2.24001,-2.72 -3.36,-1.44 l -4.96,4.96 -3.2,3.2 -0.96,0.8 -2.88,2.88 -0.64,0.8 c -0.80001,0.64 -2.08,0.64 -2.72001,0 l -9.27999,-9.28 -7.2,-7.2 -15.04,-15.04 c -0.48,-0.48 -0.64,-0.96001 -0.64,-1.44 V 522.32 c 0,-1.11999 0.96,-1.91999 2.08,-1.91999 h 0.96 c 0.64,0 1.12,0.16 1.44,0.48 l 14.4,14.4 13.27999,13.28 c 0.80001,0.8 1.92,0.8 2.72001,0 l 27.68,-27.68 c 0.32,-0.32 0.8,-0.48 1.43999,-0.48 h 0.48 c 1.12001,0 2.08001,0.8 2.08001,1.91999 z",
    style: {
      fill: "#005091",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 409.03999,594.80001 h -13.92 c -0.96,0 -1.76,-0.48 -2.24,-1.28 v -0.32 l -14.88001,-26.56 -7.2,-13.12 -0.16,-0.48 -9.91999,-17.76 v 0 l 0.8,-1.44 6.4,-11.52001 v 0 l 0.8,-1.6 v -0.15999 h 2.23999 c 0.96001,0 1.76001,0.64 2.08001,1.43999 l 0.16,0.32 v 0 l 6.39999,11.52001 31.36001,56.48 0.32,0.64 c 0.96,1.76 -0.32,3.84 -2.24,3.84 z m -54.40001,-48 9.60001,17.44 v 0.16 l -15.84,28.8 -0.16,0.32 c -0.48,0.8 -1.28001,1.28 -2.24001,1.28 h -13.91999 c -1.92,0 -3.20001,-2.08 -2.24,-3.84 l 0.32,-0.64 24.15999,-43.52 c 0.16,0 0.16,0 0.32,0 z",
    style: {
      fill: "#005091",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 479.44002,565.36 c 2.08,0 3.52,1.92 2.88,3.84 -2.4,7.36 -7.04,13.76 -13.28,18.24 -6.4,4.79999 -13.92,7.36 -21.92,7.36 -8.96,0 -17.6,-3.36 -24.32,-9.12 -6.72001,-5.92 -11.2,-13.92 -12.32,-22.56 -0.32,-1.76 -0.48001,-3.68 -0.48001,-5.44 0,-1.76 0.16001,-3.52 0.32,-5.12 1.28001,-8.8 5.60001,-16.96 12.32001,-22.72 6.71999,-5.92 15.36,-9.28 24.48,-9.28 8.16,0 15.84,2.71999 22.4,7.68 6.24,4.8 10.88,11.52 13.12,19.2 0.48,1.76 -0.8,3.68 -2.88,3.68 h -10.4 c -1.12,0 -2.24,-0.64 -2.56,-1.76 v 0 c -3.52,-8 -11.2,-12.96 -19.68,-12.96 -10.24001,0 -19.04001,7.2 -20.96,17.12 -0.32,1.28 -0.48,2.72 -0.48,4.16 0,1.44 0.16,3.04 0.48,4.48 2.07999,9.76 10.87999,16.96 20.96,16.96 8,0 15.68,-4.8 19.2,-12.16 v 0 c 0.48,-0.96 1.44,-1.6 2.56,-1.6 z",
    style: {
      fill: "#005091",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 553.03999,561.2 c 1.92,3.36 3.04,7.2 3.04,11.2 0,3.84 -1.12,7.67999 -3.04,11.04 -3.84,7.04 -11.36,11.35999 -19.36001,11.35999 h -22.23999 c -9.76001,0 -18.08,-6.72 -20.64001,-15.67999 -0.16,-0.8 -0.32,-1.76 -0.48,-2.56 -0.32,-1.76 1.12001,-3.2 2.72001,-3.2 h 9.43999 c 1.44001,0 2.88001,0.8 3.36,2.24 0.64,1.6 1.92001,2.88 3.68001,3.52 v 0 h 24.31999 c 2.56001,0 4.96001,-1.6 5.92001,-4 1.92,-4.8 -1.6,-9.44 -6.08001,-9.44 h -21.27999 c -6.24001,0 -12.16,-2.72 -16.32,-7.2 -1.12001,-1.28 -2.24001,-2.56 -3.04,-4.16 -1.92,-3.36 -3.04001,-7.2 -3.04001,-11.04 0,-4 1.12001,-7.84 3.04001,-11.20001 4,-6.87999 11.36,-11.19999 19.36,-11.19999 h 22.72 c 9.76,0 18.08,6.56 20.48,15.68 0.32,0.8 0.48,1.59999 0.64,2.4 0.16,1.76 -1.12,3.36 -2.88,3.36 h -9.76 c -1.28,0 -2.4,-0.96 -2.88,-2.08 -0.64,-1.76 -1.92,-3.04 -3.68,-3.68 v 0 h -24.8 c -2.56001,0 -4.96,1.59999 -5.92001,4 -1.91999,4.8 1.60001,9.44 6.08001,9.44 h 21.27999 c 8.00001,0 15.52001,4.32 19.36001,11.2 z",
    style: {
      fill: "#005091",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6",
    clipPath: "url(#clipPath7)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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",
    transform: "matrix(20.16,0,0,20.16,337.28,706.55997)",
    clipPath: "url(#clipPath6)",
    id: "image6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 235.12001,515.6 z m 0,0 h -0.16 c 0,0 0,0 0,0 z",
    style: {
      fill: "#00963f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g9",
    clipPath: "url(#clipPath10)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAAAyCAYAAADV5GxPAAAABHNCSVQICAgIfAhkiAAAA6ZJREFUeJztW+22oyAMnER3X+o+477xluwPwIbP2KrFu5c5pyeKIDDGOEZK+PMl6IG5exikt8n/AFCw4lxRFi0AiPS7N/Fwu6uKCBD7C5Z2di+6nR5z3CQk8weHuS4LiAiO/LwlWIPViaswiR+ESfwgTOIHYRI/CJP4QZjED8Jq1nBBJ0d9SpTqcMrqB42b6POs7KByr/a3q07N0kHfC3xEfe6Lnrq9henxgzCJH4RJ/CBM4gdhEj8Ik/hBeJl4yu2p2vA16L6LcWX2ukGUktqFfcn3VfmKh/OjE1QtEXuN6sQ3jFbCiZhPFub7EYcKACx+grmN86MwXm/JXzQi/73gVWh9TrTl4iVo+vgTJjBzQjjgx8FpSd1SwwIf8CgDLP4Xt2u2N/7DyAjoebnenzF+ECbxgzCJH4RJ/CBM4gdhEj8Idj7egKmDjXU5vZw1AMjj0T3uDGn4lk7XiP2r7xGFjtcWcf2Ot7TU53+YeBPWhwqD+FugQm6/OpnvlNcT/92Rk96yCHfvzos03OMPL+H7BBpkR8+myv79Pf7uxFdIp9zLO7aF4R5/+xifPUgLYm8baizc3eOB7mrnZ5X0AlwaamKqtYu7e3xtePnS81ZTLmO702qT221N4nfp4D35/CQffo7dPb7m5AD8rej0hDDZcu5bijceFsHy+1eS+s1allSFwnNCTS+fr0g6256FZCESsju5d0eyX8j0znDGx/jRMFSJZPWKN9c3MYmHIjn7Gw2YfNTU3q81+wH+J/ExvGhP73k7FOkHPP9nE0/wXh0ZZgofrSseXSP9zfgO/HTiI7ge3+O2qHriC+PBt7v88cTXlpzrmO6JThoAB8MMAKy8LM+O87Xt+X86a7Dy6YbOJiNff3U+XaJOB8qlKiJY1rVYqnEGuJvMGf1WeRZ6oSHz+IRc9m+iRfkJWH3fqnMRH9c+lEO5vB8zn16pt9fhjsjJTcMGwovt/8Hre/n0In6nWr7q6SdQskbv1jZCROyrf9RjB3h8EV4bHzjqoemcYW2hJif/YyHn6uylkU/PczK5Tk/P1dh+A1WP155vrgL45vl0rdOLN9LW3M8INS50FMOKiGwD4Vc4baSFL7cWlOfmOv0ZUlR5S6fnfUmjfCdWt+WePekslPwvldjrfA7rRDYPd7FOaC2BixetuUQc/fYc3gPyh2DxUNQPTZ2LqXl4dkfkkEoUehWrHqAAcMGy7HOqZK38G3l1k3yyz7MLpOzRx8YJ0fUfn/e4wshQAuUAAAAASUVORK5CYII=",
    transform: "matrix(19.52,0,0,10.4,337.76001,716.15999)",
    clipPath: "url(#clipPath9)",
    id: "image9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g11",
    clipPath: "url(#clipPath12)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOiy/M8ABUwMSAA3BwBWsQHK2INObgAAAABJRU5ErkJggg==",
    transform: "matrix(0.64,0,0,0.8,337.76001,718.87999)",
    clipPath: "url(#clipPath11)",
    id: "image11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g13",
    clipPath: "url(#clipPath14)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOi3/c8ABUwMSIBIDgBwQAHVyWLYsAAAAABJRU5ErkJggg==",
    transform: "matrix(0.64,0,0,1.12,339.20001,714.87999)",
    clipPath: "url(#clipPath13)",
    id: "image13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g15",
    clipPath: "url(#clipPath16)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAHCAYAAAAvZezQAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOiy/M+ABJgY0ABNBADPKwHQAODqIgAAAABJRU5ErkJggg==",
    transform: "matrix(0.8,0,0,1.44,347.20001,722.55999)",
    clipPath: "url(#clipPath15)",
    id: "image15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17",
    clipPath: "url(#clipPath18)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAYAAACddGYaAAAABHNCSVQICAgIfAhkiAAAABNJREFUCJljZOi1/s8ABUwMSAAAKL0By9jVA3QAAAAASUVORK5CYII=",
    transform: "matrix(0.64,0,0,0.48,348.16,721.28)",
    clipPath: "url(#clipPath17)",
    id: "image17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g19",
    clipPath: "url(#clipPath20)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOi1/s8ABUwMSACFAwBAJgHNss0ogAAAAABJRU5ErkJggg==",
    transform: "matrix(0.64,0,0,0.64,343.04001,710.08003)",
    clipPath: "url(#clipPath19)",
    id: "image19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g21",
    clipPath: "url(#clipPath22)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAABHNCSVQICAgIfAhkiAAAABJJREFUCJljYOi1/s/EwMDAAAAMEwHKFDbx1AAAAABJRU5ErkJggg==",
    transform: "matrix(0.16,0,0,0.32,343.35999,710.88001)",
    clipPath: "url(#clipPath21)",
    id: "image21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g23",
    clipPath: "url(#clipPath24)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOyx/s8ABUwMSACFAwBAJwHNFDYp/wAAAABJRU5ErkJggg==",
    transform: "matrix(0.64,0,0,0.64,343.35999,709.28004)",
    clipPath: "url(#clipPath23)",
    id: "image23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g25",
    clipPath: "url(#clipPath26)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOi3/c+ABpjQBUgTBACSbwHTRO7QCwAAAABJRU5ErkJggg==",
    transform: "matrix(1.12,0,0,0.96,340.64001,712.96004)",
    clipPath: "url(#clipPath25)",
    id: "image25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g27",
    clipPath: "url(#clipPath28)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAABHNCSVQICAgIfAhkiAAAABtJREFUGJVjZOi1/s+ABzDhkxw+ClgYmPCrAQAWjAHf2n/zFAAAAABJRU5ErkJggg==",
    transform: "matrix(1.6,0,0,1.92,340.16,711.99998)",
    clipPath: "url(#clipPath27)",
    id: "image27"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 244.56001,501.52001 c 0,-0.16 -0.16,-0.32 -0.16,-0.48 0.16,0.16 0.16,0.32 0.16,0.48 z m -0.8,-1.44 c 0,-0.16 -0.16,-0.16 -0.16,-0.32 0,0.16 0.16,0.16 0.16,0.32 z m -0.96,-1.12 c 0,-0.16 -0.16,-0.32 -0.32,-0.32 0.16,0 0.32,0.16 0.32,0.32 z m -1.12,-1.12 c -0.16,-0.16 -0.16,-0.16 -0.32,-0.16 0.16,0 0.16,0 0.32,0.16 z",
    style: {
      fill: "#00963f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    clipPath: "url(#clipPath31)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAAiCAYAAAAwG6WQAAAABHNCSVQICAgIfAhkiAAAA2dJREFUaIHtWu2SpCAM7LA+2L3jPe7e0PfDBAMCos7sjrt2lRUQFWgi+VCRv38IACSBuTAfBpGl7NtIgABinGUL7DU+AX58teYQ9DJJ0srRbnVtUWZJlTFGvQa5TNUwPNQAFES38GrSvhA238C8TjdHYV5PCnWChiCRCAQkEkIA0TSWQO2clxdYgJLIKrHIF4Bb8zo47ak6ACdr51Bb8TdGRqwISCbJpSFdJwQYMM/Nbxu+bjf2d7EME8i0smmFMzKL8siW806wcXoyXZlah1sA376yCeUC7MDkV501MnUg2blMHuz5q0Auc/AkYjGaNc0PUGNJgOUUD2g1UGwjVa3tEn0RVAhPWpx0ShCxfgu63s5OXQsSc8tsnZsBzOru/CzHO/p2DChHoPKgW6poXeh4OYEpQBKp1gFNioCPqOYaTupyjqzqoB/cAs3PPYrVnps7A6KTIAgENZoqIYLH4+F8bNGj8twBhOxVKrU72paBvrwwSt/atNlrePYWp2Bu/+STWnn3z45fA40paj545jRY3HHQbq28kZWxPPC6XAaqocn9i/NeKsFcQb0sFMYVAr0r7awjmLKw1PvaVg9tslcu0RVBIqinQvNCkmsn6ZqEFeHjCM0wduAVkat5JA0skeOyXZgk6WzXsqWsgr8BTNbBKopU2fMVTvoJ74Ga713zs72vbti5xU6eMNpDndwkVFBxDXdIzNuRRWqlTH3U7n8S6AiHplddY5tUM5iN5nKIU/ZgMebaN2QQAB/j+dzegCh1ufX8rWCj66cLgOmjfj6VbUDrlDaDIH7+y3Lllg8HkNk7AphOpTZ+goHcmkNHsyUS+FiSWNCcikA/TMQ5UDKcU8vfAjWGNT98uYTVssf0mtH9IBTZT/PJS68tO+dvw63Z46hkO1nR8posNfwmewSN9HIrxdHaRm6yt9DL5/sDlXTHrdkHsDPxdNhA9vLNlLn9OyP2sNH5VlC2mS+vzd+nZV27WL4bmrwClv9OcGv209Hbt2+yT2LEMzHcZJ/FjqzpTfYz0IowC8LvCPIsighzVXa4NftZqPnfBS5PdpTl19+WbKZvnzKAhu9JwH4RMUxb/22chWx8zTgzcf/9NIp+vy0kNggfnX8vMkw/Ulk1zUkA++8GF9dsv1BsyNcPYv0BIxTkW/t/qPv7uq9RTRQAAAAASUVORK5CYII=",
    transform: "matrix(18.879999,0,0,7.04,337.60001,706.55997)",
    clipPath: "url(#clipPath30)",
    id: "image30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    clipPath: "url(#clipPath33)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAICAYAAAA870V8AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOiy/M8ABUwMSIC6HAC0vQHSbWhaXwAAAABJRU5ErkJggg==",
    transform: "matrix(0.64,0,0,1.6,337.60001,712.63998)",
    clipPath: "url(#clipPath32)",
    id: "image32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    clipPath: "url(#clipPath35)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAABHNCSVQICAgIfAhkiAAAABRJREFUCJljZOyx/s/AwMDAxAAFABpuAcvyEwsAAAAAAElFTkSuQmCC",
    transform: "matrix(0.48,0,0,0.48,339.67999,720.47996)",
    clipPath: "url(#clipPath34)",
    id: "image34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    clipPath: "url(#clipPath37)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljZOiy/M/AwMDAxAAFmAwAOkEByo8Re20AAAAASUVORK5CYII=",
    transform: "matrix(0.32,0,0,0.96,338.07999,719.20003)",
    clipPath: "url(#clipPath36)",
    id: "image36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    clipPath: "url(#clipPath39)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOiy/M8ABUwMSACFAwA/bwHI28+TbgAAAABJRU5ErkJggg==",
    transform: "matrix(0.64,0,0,0.64,338.23999,719.84004)",
    clipPath: "url(#clipPath38)",
    id: "image38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    clipPath: "url(#clipPath41)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAABHNCSVQICAgIfAhkiAAAACJJREFUKJFjZOyx/s9ABGBkZITTMDYTMRpxgVHNo5oHsWYAwX0B6qpol0QAAAAASUVORK5CYII=",
    transform: "matrix(3.04,0,0,2.72,337.44,715.99997)",
    clipPath: "url(#clipPath40)",
    id: "image40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    clipPath: "url(#clipPath43)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAABHNCSVQICAgIfAhkiAAAABRJREFUCJljZOyx/s/AwMDAxAAFABpuAcvyEwsAAAAAAElFTkSuQmCC",
    transform: "matrix(0.32,0,0,0.32,346.72,722.88001)",
    clipPath: "url(#clipPath42)",
    id: "image42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    clipPath: "url(#clipPath45)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZOyx/s8ABUwMSIBIDgBvRwHR8t5ptwAAAABJRU5ErkJggg==",
    transform: "matrix(0.64,0,0,1.12,348,721.76)",
    clipPath: "url(#clipPath44)",
    id: "image44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    clipPath: "url(#clipPath47)",
    transform: "rotate(90,396.88,555.36)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAYAAACddGYaAAAABHNCSVQICAgIfAhkiAAAABNJREFUCJljZOiy/M8ABUwMSAAAKEcBxhumlkQAAAAASUVORK5CYII=",
    transform: "matrix(0.64,0,0,0.32,348.16,722.88001)",
    clipPath: "url(#clipPath46)",
    id: "image46"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m 227.27998,607.27999 c 0,-0.96 0.32,-1.6 0.8,-2.08 0.64,-0.48 1.44,-0.8 2.4,-0.8 1.12,0 2.24,0.48 3.04,1.44 l -1.44,1.28 c -0.64,-0.64 -1.12,-0.8 -1.76,-0.8 -0.32,0 -0.64,0 -0.8,0.16 -0.16,0.16 -0.32,0.48 -0.32,0.8 0,0.16 0,0.32 0.16,0.48 0.32,0.16 0.48,0.48 0.64,0.48 0.16,0.16 0.32,0.16 0.48,0.32 0.16,0 0.32,0.16 0.48,0.32 l 0.64,0.16 c 1.44,0.8 2.24,1.76 2.24,3.04 0,0.8 -0.32,1.44 -0.96,2.08 -0.64,0.48 -1.44,0.8 -2.4,0.8 -0.8,0 -1.44,-0.16 -2.08,-0.48 -0.64,-0.32 -1.12,-0.64 -1.6,-1.28 l 1.44,-1.28 c 0.64,0.8 1.44,1.12 2.24,1.12 0.48,0 0.8,0 0.96,-0.32 0.32,-0.16 0.48,-0.48 0.48,-0.64 0,-0.32 -0.16,-0.64 -0.48,-0.8 -0.16,-0.32 -0.48,-0.48 -0.8,-0.64 -0.16,-0.16 -0.48,-0.32 -0.96,-0.48 -1.6,-0.8 -2.4,-1.76 -2.4,-2.88 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "m 243.59999,614.80001 h -1.76 v -10.4 0 l 5.28,5.12 5.28,-5.12 v 0 10.4 h -1.76 v -6.24 l -3.36,3.36 h -0.16 l -3.52,-3.36 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m 265.03999,604.40001 h 0.16 l 4.96,10.24 -0.16,0.16 h -1.92 l -0.64,-1.6 h -4.64 l -0.8,1.6 h -1.92 v -0.16 z m 0,3.52 -1.44,3.52 h 3.04 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "m 279.59999,614.80001 h -1.92 v -10.24 h 3.68 c 1.12,0 1.92,0.32 2.56,0.96 0.8,0.64 1.12,1.44 1.12,2.56 0,1.44 -0.64,2.4 -1.76,3.04 l 2.08,3.52 v 0.16 h -1.92 l -1.76,-3.04 c -0.32,0 -0.48,0 -0.64,0 h -1.44 z m 1.44,-8.48 h -1.44 v 3.68 h 1.28 c 0.64,0 1.12,-0.16 1.6,-0.48 0.32,-0.32 0.64,-0.8 0.64,-1.44 0,-0.48 -0.16,-0.96 -0.64,-1.28 -0.32,-0.32 -0.8,-0.48 -1.44,-0.48 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m 297.03999,614.80001 h -1.92 v -8.32 h -3.2 v -1.92 h 8.48 v 1.92 h -3.36 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "m 334.8,613.04 c 1.12,0 1.92,-0.32 2.56,-1.28 l 1.44,1.44 c -1.12,1.12 -2.4,1.76 -4,1.76 -1.44,0 -2.72,-0.48 -3.68,-1.44 -0.96,-1.12 -1.44,-2.4 -1.44,-3.84 0,-1.44 0.48,-2.72 1.44,-3.68 0.96,-1.12 2.24,-1.6 3.68,-1.6 1.6,0 2.72,0.48 3.84,1.6 l -1.44,1.28 c -0.64,-0.64 -1.44,-0.96 -2.4,-0.96 -0.96,0 -1.76,0.32 -2.24,0.96 -0.64,0.64 -0.96,1.44 -0.96,2.4 0,0.96 0.32,1.76 0.8,2.4 0.64,0.64 1.44,0.96 2.4,0.96 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m 350.48,604.40001 h 0.16 l 4.96,10.24 -0.16,0.16 h -1.92 l -0.8,-1.6 h -4.48 l -0.8,1.6 h -1.92 v -0.16 z m 0,3.52 -1.44,3.52 h 3.04 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 365.03999,614.80001 h -1.92 v -10.24 h 3.68 c 0.96,0 1.92,0.32 2.56,0.96 0.64,0.64 1.12,1.44 1.12,2.56 0,1.44 -0.64,2.4 -1.76,3.04 l 2.08,3.52 v 0.16 h -1.92 l -1.92,-3.04 c -0.32,0 -0.48,0 -0.48,0 h -1.44 z m 1.44,-8.48 h -1.44 v 3.68 h 1.12 c 0.8,0 1.28,-0.16 1.76,-0.48 0.32,-0.32 0.48,-0.8 0.48,-1.44 0,-0.48 -0.16,-0.96 -0.48,-1.28 -0.32,-0.32 -0.8,-0.48 -1.44,-0.48 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m 384.88002,613.04 v 1.76 h -6.08 v -10.24 h 6.08 v 1.76 h -4.16 v 2.88 h 3.52 v 1.6 h -3.52 v 2.24 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m 423.59999,607.27999 c 0,-0.96 0.32,-1.6 0.96,-2.08 0.48,-0.48 1.28,-0.8 2.24,-0.8 1.12,0 2.24,0.48 3.04,1.44 l -1.44,1.28 c -0.48,-0.64 -1.12,-0.8 -1.76,-0.8 -0.32,0 -0.64,0 -0.8,0.16 -0.16,0.16 -0.32,0.48 -0.32,0.8 0,0.16 0.16,0.32 0.32,0.48 0.16,0.16 0.32,0.48 0.64,0.48 0,0.16 0.16,0.16 0.32,0.32 0.32,0 0.48,0.16 0.48,0.32 l 0.64,0.16 c 1.44,0.8 2.24,1.76 2.24,3.04 0,0.8 -0.32,1.44 -0.96,2.08 -0.64,0.48 -1.44,0.8 -2.4,0.8 -0.64,0 -1.44,-0.16 -2.08,-0.48 -0.64,-0.32 -1.12,-0.64 -1.44,-1.28 l 1.28,-1.28 c 0.64,0.8 1.44,1.12 2.24,1.12 0.48,0 0.8,0 0.96,-0.32 0.32,-0.16 0.48,-0.48 0.48,-0.64 0,-0.32 -0.16,-0.64 -0.48,-0.8 -0.16,-0.32 -0.48,-0.48 -0.64,-0.64 -0.32,-0.16 -0.64,-0.32 -1.12,-0.48 -1.6,-0.8 -2.4,-1.76 -2.4,-2.88 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "m 441.84001,604.40001 h 0.16 l 4.96,10.24 v 0.16 h -2.08 l -0.64,-1.6 h -4.64 l -0.64,1.6 h -1.92 l -0.16,-0.16 z m 0.16,3.52 -1.6,3.52 h 3.04 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m 456.56001,614.80001 h -1.92 v -10.24 h 6.08 v 1.76 h -4.16 v 3.04 h 3.52 v 1.76 h -3.52 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "m 474.64,613.04 v 1.76 h -6.08 v -10.24 h 6.08 v 1.76 h -4.16 v 2.88 H 474 v 1.6 h -3.52 v 2.24 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m 505.03999,613.04 c 1.12,0 2.08,-0.32 2.72,-1.28 l 1.44,1.44 c -1.12,1.12 -2.56,1.76 -4.16,1.76 -1.44,0 -2.56,-0.48 -3.68,-1.44 -0.96,-1.12 -1.44,-2.4 -1.44,-3.84 0,-1.44 0.48,-2.72 1.44,-3.68 1.12,-1.12 2.24,-1.6 3.84,-1.6 1.44,0 2.72,0.48 3.68,1.6 l -1.28,1.28 c -0.64,-0.64 -1.44,-0.96 -2.4,-0.96 -0.96,0 -1.76,0.32 -2.4,0.96 -0.64,0.64 -0.96,1.44 -0.96,2.4 0,0.96 0.32,1.76 0.96,2.4 0.64,0.64 1.44,0.96 2.24,0.96 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "m 520.72002,604.40001 h 0.16 l 4.96,10.24 v 0.16 h -2.08 l -0.64,-1.6 h -4.64 l -0.64,1.6 h -1.92 l -0.16,-0.16 z m 0.16,3.52 -1.6,3.52 h 3.04 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 535.44002,614.80001 h -1.92 v -10.24 h 3.68 c 0.96,0 1.76,0.32 2.56,0.96 0.64,0.64 0.96,1.44 0.96,2.56 0,1.44 -0.48,2.4 -1.6,3.04 l 2.08,3.52 -0.16,0.16 h -1.92 l -1.76,-3.04 c -0.32,0 -0.48,0 -0.48,0 h -1.44 z m 1.28,-8.48 h -1.28 v 3.68 h 1.12 c 0.64,0 1.12,-0.16 1.6,-0.48 0.48,-0.32 0.64,-0.8 0.64,-1.44 0,-0.48 -0.16,-0.96 -0.48,-1.28 -0.48,-0.32 -0.96,-0.48 -1.6,-0.48 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "m 555.28001,613.04 v 1.76 h -6.08 v -10.24 h 6.08 v 1.76 h -4.16 v 2.88 h 3.52 v 1.6 h -3.52 v 2.24 z",
    style: {
      fill: "#00a55e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "m 556.08,519.27999 c -5.44001,0 -9.76,-4.32 -9.76,-9.44 0,-5.28 4.31999,-9.60001 9.76,-9.60001 5.28,0 9.6,4.32001 9.6,9.60001 0,5.12 -4.32,9.44 -9.6,9.44 z m 11.04,-14.24 c -0.64,-1.28 -1.44,-2.56 -2.56,-3.68 -1.12,-1.12001 -2.4,-2.08 -3.84,-2.56 -1.44,-0.64001 -3.04,-0.96001 -4.64,-0.96001 -1.6,0 -3.20001,0.32 -4.8,0.96001 -1.44,0.48 -2.72,1.43999 -3.84,2.56 -1.12,1.12 -1.92,2.4 -2.56001,3.68 -0.63999,1.6 -0.95999,3.04 -0.95999,4.8 0,1.6 0.32,3.04 0.95999,4.64 0.64001,1.44 1.44001,2.72 2.56001,3.68 1.12,1.12 2.4,2.08 3.84,2.56 1.59999,0.64 3.2,0.96 4.8,0.96 1.6,0 3.2,-0.32 4.64,-0.96 1.44,-0.48 2.72,-1.44 3.84,-2.56 1.12,-0.96 1.92,-2.24 2.56,-3.68 0.63999,-1.6 0.96,-3.04 0.96,-4.64 0,-1.76 -0.32001,-3.2 -0.96,-4.8 z",
    style: {
      fill: "#005091",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "m 555.75999,508.71999 h -2.24 v -4.16 c 0.48,0 1.12,0 1.76,0 2.56,0 3.68,0.64 3.68,2.08 0,1.44 -1.12,2.08 -3.2,2.08 z m 4.96,3.04 c -0.48,-0.8 -0.96,-1.44 -1.6,-1.92 1.44,-0.64 2.24,-1.76 2.24,-3.36 0,-1.28 -0.64,-2.24 -1.76,-2.88 -0.96,-0.8 -2.4,-1.12 -4.32,-1.12 -1.12,0 -2.56,0.16 -4,0.32 l -0.16,0.16 v 13.6 h 2.4 v -5.76 h 2.24 c 0.96,0 1.76,0.32 2.24,1.28 0.64,0.96 1.12,2.4 1.44,4.32 v 0.16 h 2.4 v -0.32 c -0.32,-2.08 -0.8,-3.52 -1.12,-4.48 z",
    style: {
      fill: "#005091",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImacsLogo);
export default __webpack_public_path__ + "static/media/imacs_logo.ba9515ce79143f7864bbce7a1cf1509b.svg";
export { ForwardRef as ReactComponent };